import {
  Database,
  CalendarClock,
  ShieldCheck,
  FileText,
  History,
  FileSignature,
  ArrowRight,
} from "lucide-react";
import { requestLead } from "@/lib/leadIntent";
import { trackEvent, EVENTS } from "@/lib/tracking";
import { Reveal } from "@/components/Reveal";

const FEATURES = [
  { icon: Database, title: "Asset Register", desc: "Pendataan unit AC yang Anda kelola." },
  { icon: CalendarClock, title: "Maintenance Schedule", desc: "Jadwal perawatan yang terencana." },
  { icon: ShieldCheck, title: "Preventive Maintenance", desc: "Perawatan pencegahan berkala." },
  { icon: FileText, title: "Service Report", desc: "Laporan pekerjaan setiap kunjungan." },
  { icon: History, title: "Maintenance History", desc: "Riwayat perawatan yang terdokumentasi." },
  { icon: FileSignature, title: "Maintenance Contract", desc: "Program kontrak sesuai kebutuhan." },
];

export const B2BValueSection = () => {
  return (
    <section
      id="b2b-value"
      data-testid="b2b-value-section"
      className="relative overflow-hidden bg-[#0F172A] py-20 sm:py-24 lg:py-28"
    >
      <div
        className="absolute inset-0 opacity-[0.05]"
        style={{
          backgroundImage:
            "linear-gradient(to right, #fff 1px, transparent 1px), linear-gradient(to bottom, #fff 1px, transparent 1px)",
          backgroundSize: "56px 56px",
        }}
        aria-hidden="true"
      />
      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid gap-12 lg:grid-cols-[1fr_1.1fr] lg:gap-16">
          <div className="lg:sticky lg:top-28 lg:self-start">
            <Reveal>
              <div className="mb-4 flex items-center gap-3">
                <span className="text-sm font-bold uppercase tracking-[0.2em] text-slate-400">
                  Solusi Perusahaan
                </span>
                <span className="h-px w-10 bg-[#E0A400]/50" />
              </div>
            </Reveal>
            <Reveal delay={0.05}>
              <h2 className="text-3xl font-extrabold leading-[1.12] tracking-tight text-white sm:text-4xl lg:text-[2.6rem]">
                Punya Banyak AC?
              </h2>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="mt-5 text-base leading-relaxed text-slate-300 sm:text-lg">
                Semakin banyak unit, semakin penting maintenance yang terjadwal
                dan terdokumentasi. SEJUKARA CARE membantu perusahaan mengelola
                perawatan AC & HVAC secara terstruktur.
              </p>
            </Reveal>
            <Reveal delay={0.15}>
              <button
                type="button"
                onClick={() => {
                  trackEvent(EVENTS.REQUEST_AC_ASSESSMENT, { source: "b2b_value" });
                  requestLead({ audience: "b2b", kebutuhan: "Preventive Maintenance" });
                }}
                data-testid="b2b-assessment-cta"
                className="group mt-8 inline-flex items-center gap-2.5 rounded-lg bg-[#E0A400] px-7 py-4 text-[15px] font-bold text-[#0F172A] transition-colors hover:bg-[#c9930a]"
              >
                REQUEST AC ASSESSMENT
                <ArrowRight className="h-5 w-5 transition-transform group-hover:translate-x-1" />
              </button>
            </Reveal>
          </div>

          <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
            {FEATURES.map((f, i) => {
              const Icon = f.icon;
              return (
                <Reveal key={f.title} delay={(i % 2) * 0.08}>
                  <div className="group flex items-start gap-4 rounded-xl border border-white/10 bg-white/[0.03] p-5 transition-colors duration-300 hover:border-[#E0A400]/40 hover:bg-white/[0.06]">
                    <span className="flex h-11 w-11 flex-none items-center justify-center rounded-lg bg-[#E0A400]/10 text-[#E0A400]">
                      <Icon className="h-5 w-5" />
                    </span>
                    <div>
                      <h3 className="text-base font-bold text-white">{f.title}</h3>
                      <p className="mt-1 text-sm leading-relaxed text-slate-400">{f.desc}</p>
                    </div>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default B2BValueSection;
